import { universal } from '../../../loadable';

export const LoadableGetCertifiedLink = universal(
  import('./ConnectedGetCertifiedLink'),
  {
    key: 'ConnectedGetCertifiedLink',
  }
);
